<template>
  <v-snackbar
    v-bind="$attrs"
    v-on="$listeners"
    timeout="10000"
    centered
    :color="color"
    :vertical="true"
  >
    <v-container fluid>
      <v-row justify="center" align="center">
        <v-col cols="2" class="px-0">
          <div class="text-center">
            <v-icon size="65">{{ icon }}</v-icon>
          </div>
        </v-col>
        <v-col cols="10">
          <span class="text-body-1 font-weight-light">
            {{ message }}
          </span>
        </v-col>
      </v-row>
    </v-container>
    <slot></slot>
  </v-snackbar>
</template>

<script>
export default {
  name: "thesnackbar",
  data: () => ({}),
  props: {
    color: {
      type: String
    },
    icon: {
      type: String
    },
    message: {
      type: String
    }
  }
};
</script>
